// Boot the live timer on the scoreboard. Replaces server-rendered placeholder
// every second by calling PoFlashBulbs.renderBulbs.
// Targets ALL [data-flash-timer] elements but skips any with data-flash-timer-textonly
// (e.g. the announce bar, which manages its own text countdown inline).
(function () {
  function boot() {
    if (!window.PoFlashBulbs) return;
    const els = document.querySelectorAll('[data-flash-timer]');
    els.forEach(el => {
      const endAt = el.getAttribute('data-end-at');
      if (!endAt) return;
      // Skip elements that opt out of bulb rendering (e.g. announce bar with text-only timer)
      if (el.hasAttribute('data-flash-timer-textonly')) return;
      const color = el.getAttribute('data-flash-timer-color') || '#ffe9b8';
      window.PoFlashBulbs.startTimer(el, endAt, color);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
